import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Card from "../../../components/Cards/Card";
import { useQlik } from "../../../context/Qlik";
import NativeObject from "../../../components/NativeObject/NativeObject";
import utils from "../../../QlikUtils";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
});

function DetailDesktop({ app, config }) {
  const { cards } = config.performanceDetail;

  return (
    <div className="app investments">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper></LayoutCardWrapper>
          {/* KPIS */}
          <LayoutCardWrapper style={{ height: "100%" }}>
            <Card
              exportTable
              app={app}
              exportTableId="f7e67468-63da-4bc6-be90-850184cdcc40"
              header={{
                hardTitle: "Performance Geral",
                tooltip:
                  "Em performance geral, temos a visão unificada dos 3 KPI's do canal (Sell out, Cobertura Total e Cobertura Qualificada) da Meta vs Realizado, por regional e por distribuidor",
              }}
              style={{ width: "100%", alignItems: "center" }}
            >
              <NativeObject
                app={app}
                key="f7e67468-63da-4bc6-be90-850184cdcc40"
                reference={{ id: "f7e67468-63da-4bc6-be90-850184cdcc40" }}
                style={{ marginTop: "20px" }}
              />
            </Card>
          </LayoutCardWrapper>
          {/* KAPI E GRAFICO CENTRAL */}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DetailDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailDesktop;
